<template>
  <div class="design-preference-ipt-number" @mousedown="onMouseDown">
    <el-input-number 
        :precision="precision"
        v-bind="$attrs"
        >
    </el-input-number>
    <div class="unit">{{ suffix }}</div>
  </div>
</template>

<script setup>
import { ref, defineProps, useAttrs, defineEmits, computed, onMounted, nextTick } from 'vue';
import { ElInputNumber } from '@shining3d/xl-element-plus'
import {
  XlInputNumber
} from '@shining3d/ui-components';
import { countDecimalPlaces } from '../../../utils/common.js';
import { onClickOutside } from '@vueuse/core';

const active = ref( false );
const props = defineProps({
    suffix: String,
    preValue: String
});

const $attrs = useAttrs();

const emits = defineEmits(['mousedown']);

const precision = computed(() => {
    let number = 2;
    try {
        const { min, max, step } = $attrs;
        const preValue = props.preValue;
        const minLen = countDecimalPlaces(min);
        const maxLen = countDecimalPlaces(max);
        const stepLen = countDecimalPlaces(step);
        const valLen = countDecimalPlaces(preValue);
        const decimal = Math.max(minLen, maxLen, stepLen, valLen);
        number = decimal < 2 ? 2 : decimal;
    } catch(e) {
        console.log(e);
    }
    return props.suffix === '°' ? 0 : number;
});

const onMouseDown = () => {
    emits('mousedown');
};

</script>
<script>
export default {
    inheritAttrs: false
}
</script>

<style lang="scss">
.design-preference-ipt-number {
    position: relative;
    font-family: 'Alibaba PuHuiTi 2.0';
    .xl-input-number.xl-input-number__controls {
        width: 204px;
        .el-input__inner {
            text-align: left;
            padding-right: 42px;
            background: #fff !important;
        }
        .el-input-number__decrease,
        .el-input-number__increase {
            background: #FAFBFD !important;
        }
    }
    .unit {
        position: absolute;
        height: 34px;
        top: 1px;
        right: 40px;
        font-size: 14px;
        font-weight: 400;
        line-height: 34px;
        color: #737E99;
    }
    .el-input-number{
        width: 204px;
        .el-input__inner{
            font-size: 14px;
            font-weight: 400;
            line-height: 22px;
            text-align: left;
            padding-left: 40px !important;
            color: #737E99;
        }
    }
    .el-input{
        --el-input-hover-border-color: #dcdfe6 !important;
    }
}
</style>